import { styled } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";

export default styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  padding: `6px ${theme.spacing(1)}px`,
  width: "fit-content",
  display: "flex",
}));
